// removed by extract-text-webpack-plugin
module.exports = {"control":"_2APW1F80JDL25NJL0JNVov"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/CurrencySelect.scss
// module id = 1563
// module chunks = 0